import gql from "graphql-tag";

// --------- all videos ---------

export const FETCH_ALL_VIDEOS = gql`
  query FETCH_ALL_VIDEOS {
    allVideos {
      id
      name
      description
      ordering
      active
      sources {
        id
        thumbSrc
      }
    }
  }
`;

export const REORDER_VIDEOS = gql`
  mutation REORDER_VIDEOS($ordering: [VideoInput]) {
    reorderVideos(ordering: $ordering) {
      videos {
        id
        ordering
      }
    }
  }
`;

// --------  Video  ---------

export const FETCH_VIDEO = gql`
  query FETCH_VIDEO($id: ID!) {
    video(id: $id) {
      id
      name
      description
      active
      sources {
        id
        filename
        thumbSrc
        status
        height
        sourceUrl
        convertedVideoSrc
      }
    }
  }
`;

export const CREATE_VIDEO = gql`
  mutation CREATE_VIDEO($name: String, $description: String) {
    createVideo(name: $name, description: $description) {
      video {
        id
      }
    }
  }
`;

export const UPDATE_VIDEO = gql`
  mutation UPDATE_VIDEO(
    $id: ID!
    $name: String
    $description: String
    $active: Boolean
  ) {
    updateVideo(
      id: $id
      name: $name
      description: $description
      active: $active
    ) {
      video {
        id
        name
        description
        active
      }
    }
  }
`;

// --------  Video Source -----

export const CREATE_VIDEO_SOURCE = gql`
  mutation CREATE_VIDEO_SOURCE($videoId: ID!, $file: Upload!) {
    createVideoSource(videoId: $videoId, file: $file) {
      video {
        id
        sources {
          id
        }
      }
    }
  }
`;

export const UPDATE_VIDEO_SOURCE = gql`
  mutation UPDATE_VIDEO_SOURCE($id: ID!, $file: Upload!) {
    updateVideoSource(id: $id, file: $file) {
      videoSource {
        id
      }
    }
  }
`;

export const DELETE_VIDEO_SOURCE = gql`
  mutation DELETE_VIDEO_SOURCE($id: ID!) {
    deleteVideoSource(id: $id) {
      video {
        id
        sources {
          id
        }
      }
    }
  }
`;
